import React, { FC, useEffect, useState } from 'react';
import { errorModalViewStore, loadingModalViewStore } from 'src/store/modal';
import { getMemberInfo } from 'src/utils/common';
import { useQueryClient } from '@tanstack/react-query';
import { familyDataStore } from 'src/store/familyInfo';

import { creditcardInfoDataFn } from 'src/fetch/stepC/card';
import { creditcardDataStore } from 'src/store/creditcard';
import TabButton from 'src/components/atoms/buttons/TabButton';
import CreditGrid from 'src/components/molecules/table/CreditcardGrid';
import DebitcardGrid from 'src/components/molecules/table/DebitcardGrid';
import CashReceiptGrid from 'src/components/molecules/table/CashReceiptGrid';
import ZeropayGrid from 'src/components/molecules/table/ZeropayGrid';

import './style.scss';

interface Props {
  type: string;
}
const CreditCardSet: FC<Props> = ({ type }) => {
  const userInfoData: any = getMemberInfo();
  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const familyInfoDataState = familyDataStore((state: any) => state.bind);
  const loadingSate = loadingModalViewStore((state: any) => state.set);
  const param = userInfoData;

  // 카드내역
  const creditcardDataState = creditcardDataStore((state: any) => state.bind);
  const bindCreditcardParam = creditcardDataStore((state: any) => state.param);

  // 카드
  useEffect(() => {
    creditcardInfoDataFn(
      errorModalState,
      param,
      creditcardDataState,
      queryClient,
      familyInfoDataState
    );
  }, [bindCreditcardParam]);

  const setContent = () => {
    const selectMenu = menuState.menu.find(item => item.active);
    const selectId = selectMenu?.id || 'credit';
    return <CreditGrid cardType={selectId} />;
  };

  const tabMenu = [
    { active: true, title: '신용카드', id: 'credit' },
    { active: false, title: '직불카드', id: 'debit' },
    { active: false, title: '현금영수증', id: 'cash' },
    { active: false, title: '제로페이', id: 'zero' },
  ];
  const [menuState, setMenuState] = useState({ menu: tabMenu });

  const tabClickEvent = (selectItem: any) => {
    menuState.menu.forEach(item => {
      item.active = false;
      if (item.id === selectItem.id) item.active = true;
    });
    setMenuState({ menu: menuState.menu });
  };

  return (
    <div className="_creditcard_view_set_insert_div">
      <section className="_tab_button_div">
        <TabButton
          menu={menuState.menu}
          clickEvt={tabClickEvent}
          styleDef={{ height: '32px', fontSize: '13px' }}
        />
      </section>
      <section className="_content_div">
        <div className="_detail_info">{setContent()}</div>
      </section>
    </div>
  );
};

export default CreditCardSet;
